export default __webpack_public_path__ + "static/media/doopage_logo_blue.c0d6861a.png";